import {
  ButtonLoading,
  SimpleDialog,
  CustomCaptchaComponent,
  InputV2,
  Icons,
  PriceLabel,
} from 'components';
import {
  Grid,
  Typography,
  TableContainer,
  Table,
  TableBody,
  TableCell,
  TableRow,
  Button,
  useMediaQuery,
} from '@mui/material';
import { useCurrencyUnit } from 'hooks';

import { useStyles } from './style';
const DetailsDg = ({
  isConfirmModalOpen,
  handleCloseModal,
  onClickTaeid = () => {},
  submitting,
  foundUser,
  watch,
  methods,
  startDate,
  expireDate,
  guilds,
  usages,
  isGroup,
  captchaRef,
  setCaptchaIdDialog,
  setEnteredCaptcha,
  enteredCaptcha,
  infoType,
  dataType,
}) => {
  const classes = useStyles();
  const matches = useMediaQuery('(max-width:600px)');
  const currencyText = useCurrencyUnit(false);
  const USE_PERIODS = [
    { value: 'DAY_PERIOD', label: 'روز' },
    { value: 'MONTH_PERIOD', label: 'ماه' },
    { value: 'YEAR_PERIOD', label: 'سال' },
  ];
  const getPeriodLabel = (item) => {
    const items = {
      DAY_PERIOD: 'روز',
      MONTH_PERIOD: 'ماه',
      YEAR_PERIOD: 'سال',
    };
    return item ? items[item] : null;
  };

  return (
    <>
      <SimpleDialog
        title="تخصیص اعتبار با جزئیات زیر انجام گیرد؟"
        open={isConfirmModalOpen}
        icon={<Icons icon="coin" color="#000" size="25" />}
        actions={
          <>
            <ButtonLoading
              name="تایید"
              onClick={onClickTaeid}
              loading={submitting}
              variant="contained"
              color="primary"
              disabled={submitting || !enteredCaptcha || !String(enteredCaptcha).trim()}
            />
            <Button onClick={handleCloseModal} variant="contained" disabled={submitting}>
              انصراف
            </Button>
          </>
        }
      >
        <TableContainer className={classes.tableContainer}>
          <Table className={classes.table} aria-label="simple table">
            <TableBody>
              {!isGroup ? (
                <>
                  <TableRow>
                    <TableCell className={classes.titleCell} component="th" scope="row">
                      {infoType}
                    </TableCell>
                    <TableCell className={classes.boldCell}>{dataType}</TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.titleCell} component="th" scope="row">
                      میزان اعتبار
                    </TableCell>
                    <TableCell className={classes.boldCell}>
                      <Typography>
                        <PriceLabel amount={watch('amount')} />
                        <span className={classes.currencyText}> {currencyText}</span>
                      </Typography>
                    </TableCell>
                  </TableRow>
                  <TableRow>
                    <TableCell className={classes.titleCell} component="th" scope="row">
                      تاریخ انقضا
                    </TableCell>
                    <TableCell className={classes.boldCell}>
                      <Typography>
                        {expireDate ? expireDate.format('23:59 jYYYY/jMM/jDD') : '-'}
                      </Typography>
                    </TableCell>
                  </TableRow>
                </>
              ) : (
                <TableRow>
                  <TableCell className={classes.titleCell} component="th" scope="row">
                    تاریخ شروع
                  </TableCell>
                  <TableCell className={classes.boldCell}>
                    <Typography>
                      {startDate ? startDate.format('00:00 jYYYY/jMM/jDD') : '-'}
                    </Typography>
                  </TableCell>
                </TableRow>
              )}
              <TableRow>
                <TableCell className={classes.titleCell} component="th" scope="row">
                  شرح
                </TableCell>
                <TableCell className={classes.boldCell}>
                  <Typography>{String(watch('description')).trim() || '-'}</Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.titleCell} component="th" scope="row">
                  محدودیت محل مصرف
                  <br />
                  (حساب‌های تفصیلی)
                </TableCell>
                <TableCell className={classes.boldCell}>
                  <Typography>
                    {guilds.length > 0
                      ? guilds.map((v, k) => (
                          <span key={k}>{`${v.name}${k < guilds.length - 1 ? '،' : ''} `}</span>
                        ))
                      : 'ندارد'}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.titleCell} component="th" scope="row">
                  محدودیت محل مصرف
                  <br />
                  (کسب‌وکارها)
                </TableCell>
                <TableCell className={classes.boldCell}>
                  <Typography>
                    {usages.length > 0
                      ? usages.map((v, k) => (
                          <span key={k}>{`${v.name}${k < usages.length - 1 ? '،' : ''} `}</span>
                        ))
                      : 'ندارد'}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.titleCell} component="th" scope="row">
                  محدودیت میزان مصرف
                </TableCell>
                <TableCell className={classes.boldCell}>
                  <Typography>
                    {!watch('maxTryCount') && !watch('usePeriod') ? 'ندارد' : ''}
                    {watch('maxTryCount') ? `${watch('maxTryCount')} مرتبه` : ''}
                    {watch('maxTryCount') && watch('usePeriod') && watch('usePeriodCount')
                      ? ' در هر '
                      : ''}
                    {watch('usePeriod') && watch('usePeriodCount')
                      ? `${watch('usePeriodCount')} ${
                          USE_PERIODS.find((v) => v.value === watch('usePeriod'))?.label ?? ''
                        }`
                      : ''}
                  </Typography>
                </TableCell>
              </TableRow>
              <TableRow>
                <TableCell className={classes.titleCell} component="th" scope="row">
                  تمدید خودکار دوره‌ای
                </TableCell>
                <TableCell className={classes.boldCell}>
                  <Typography>
                    {watch('periodCode') && watch('periodCode')
                      ? `هر ${watch('periodCount')} ${getPeriodLabel(watch('periodCode'))} یک بار`
                      : 'ندارد'}
                  </Typography>
                </TableCell>
              </TableRow>
            </TableBody>
          </Table>
        </TableContainer>
        <Grid container wrap={matches ? 'wrap' : 'nowrap'}>
          <InputV2
            label="کدامنیتی"
            forceValue={enteredCaptcha}
            onChangeValue={(e) => {
              const value = e.target.value;
              if (value.length > 5) {
                e.preventDefault();
                setEnteredCaptcha(value.slice(0, 5));
              } else {
                setEnteredCaptcha(value);
              }
            }}
            englishNumber
            rules={['isNumeric']}
            fullWidth
            dir="ltr"
            name="captchaValue"
            onKeyPress={(e) => {
              // مکانیزم کلیک بر روی دکمه اینتر نیز پیاده شد - تکس باکس کد امنیتی خالی نباشد و فکوس بر روی همین تکس باکس باشد
              if (e?.key == 'Enter' && enteredCaptcha && String(enteredCaptcha).trim()) {
                onClickTaeid();
              }
            }}
          />
          <CustomCaptchaComponent
            pageTitle="/DelegationToUser - تفیض وجه - دیالوگ بعد از آپلود"
            ref={captchaRef}
            setCaptchaId={setCaptchaIdDialog}
            setEnteredCaptcha={setEnteredCaptcha}
            sizeOptions={{ xs: '12', md: '10', lg: '10' }}
          />
        </Grid>
      </SimpleDialog>
    </>
  );
};

export default DetailsDg;
